module.exports = __webpack_public_path__ + "static/sys_ph04-249536a46998136da186c5cefdf525d6.jpg";